import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikProps } from "formik";
import FilterDialogForm from "./FilterDialogForm";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import {
  setActionBy,
  setActionEndDate,
  setActionStartDate,
  setRequestStartDate,
  setRequestEndDate,
  setBatch,
  setIsShowMarkSpam ,
  setRequestStatus
} from "src/redux/slices/RegistrationRequestsSlice";

export type FilterDialogFormWrapperValues = {
  actionBy: any;
  actionEndDate: any;
  actionStartDate: any;
  requestStartDate: any;
  requestEndDate: any;
  batch: any;
  // requestStatus:'COMPLETED' | 'PENDING' ;
  requestStatus :any ;
  isShowMarkSpam : boolean ;
};

type Props = {
  onClose: () => void;
};

const FilterDialogFormWrapper = ({ onClose }: Props) => {
  const dispatch = useDispatch();

  const {
    actionBy,
    actionEndDate,
    actionStartDate,
    requestStartDate,
    requestEndDate,
    batch,
    requestStatus ,
    isShowMarkSpam
  } = useSelector((state: RootState) => state.registrationRequest);

  // Form Initial Values
  const initialValues: FilterDialogFormWrapperValues = {
    requestStatus :{
      label:requestStatus?.label ,
      value : requestStatus?.value
    },
    isShowMarkSpam:isShowMarkSpam,
    actionBy:{
        label:actionBy?.label ,
        value : actionBy?.value ,
    },
    actionEndDate: actionEndDate || null,
    actionStartDate: actionStartDate || null,
    requestStartDate: requestStartDate || null,
    requestEndDate:requestEndDate || null,
    batch:{
        label:batch?.label ,
        value : batch?.value ,
    },
  };

  // Validation Schema
//   const validationSchema = object().shape({
//     name: string().required("Please enter name"),
//     age: string().required("Please enter age"),
//   });

  // Handle Submit
  const handleSubmit = (
    values: FilterDialogFormWrapperValues,
  ) => {
  dispatch(setActionStartDate(values?.actionStartDate)) ;
  dispatch(setActionEndDate(values?.actionEndDate));
  dispatch(setRequestStartDate(values?.requestStartDate));
  dispatch(setRequestEndDate(values?.requestEndDate)) ;
  dispatch(setBatch(values?.batch)) ;
  dispatch(setActionBy(values?.actionBy)) ;
  dispatch(setRequestStatus(values?.requestStatus));
  dispatch(setIsShowMarkSpam(values?.isShowMarkSpam))
  onClose()
  };


  //Handel Reset

  const handleReset =(formikProps:FormikProps<FilterDialogFormWrapperValues>)=>{
    dispatch(setActionStartDate(null)) ;
    dispatch(setActionEndDate(null));
    dispatch(setRequestStartDate(null));
    dispatch(setRequestEndDate(null)) ;
    dispatch(setBatch(null)) ;
    dispatch(setActionBy('')) ;
    dispatch(setRequestStatus(null));
  dispatch(setIsShowMarkSpam(false))
  }

  return (
    <Dialog open maxWidth="sm" fullWidth>
      <Formik 
      enableReinitialize
        initialValues={initialValues}
        // validationSchema={validationSchema}
        onSubmit={handleSubmit}
        
      >
        {(formikProps) => (
          <Form>
            <FilterDialogForm formikProps={formikProps} onClose={onClose} handleReset={handleReset} />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default FilterDialogFormWrapper;
